import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  FetchTokensUseCaseInput,
  FetchTokensUseCaseOutput,
  IAppErrorFactory,
  IFetchTokensUseCase,
  ITokensService,
} from '../../types'

@injectable()
export default class FetchTokensInteractor implements IFetchTokensUseCase {
  @inject(symbols.ITokensService) private tokenService: ITokensService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: FetchTokensUseCaseInput): Promise<FetchTokensUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.tokens = await this.tokenService.fetchTokens(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): FetchTokensUseCaseOutput {
    return {
      tokens: [],
      error: null,
    }
  }
}
